/** Normalise Australian phone input for validation / API (spaces, +61, leading 61). */
export function normalizeAustralianPhone(value) {
  let s = String(value ?? "").trim().replace(/[\s.-]/g, "");
  if (s.startsWith("+61")) return "0" + s.slice(3);
  if (s.startsWith("61") && s.length >= 11) return "0" + s.slice(2);
  return s;
}

/** True if value is a valid AU mobile (04…) or landline (0[2-478]…), after normalisation. */
export function isValidAustralianPhone(value) {
  const s = normalizeAustralianPhone(value);
  if (!s) return false;
  return /^04\d{8}$/.test(s) || /^0[2-478]\d{8}$/.test(s);
}

/** Basic email shape check (aligned with typical FormKit `email` rule). */
export function isValidEmailBasic(value) {
  const v = String(value ?? "").trim();
  if (!v) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
